/** Libellés des tranches d'âge tels qu'affichés dans la pyramide */
const BRACKET_LABELS = {
    "55+": "55 ans +",
    "45-54": "45–54",
    "35-44": "35–44",
    "25-34": "25–34",
    "< 25": "< 25",
};

/**
 * Transforme la réponse de GET /hr/pilotage/diversite en modèle
 * consommé par DiversiteSection.
 */
export const mapDiversite = (api) => {
    const gender = api.gender ?? {};

    return {
        pyramide: (api.age_pyramid ?? []).map((row) => ({
            tranche: BRACKET_LABELS[row.bracket] ?? row.bracket,
            femmes: row.women ?? 0,
            hommes: row.men ?? 0,
        })),
        genre: {
            femmes: gender.women ?? 0,
            hommes: gender.men ?? 0,
            autre: gender.other ?? 0,
            femmesPct: gender.women_pct ?? 0,
            hommesPct: gender.men_pct ?? 0,
            autrePct: gender.other_pct ?? 0,
        },
        total: (gender.women ?? 0) + (gender.men ?? 0) + (gender.other ?? 0),
        ageMoyen: api.average_age ?? 0,
        femmesManagement: api.women_in_management_pct ?? 0,
    };
};
